import { HashRouter, Routes, Route } from 'react-router';
import './App.css';
import { GamesList } from './GamesList';
import Login from './Login';
import AuthGuard from './AuthGuard';
import Subscribe from './Subscribe';
import Menu from './Menu'

function App() {
  return (
    <HashRouter>
      <Menu />
      <Routes>
        <Route path="/" element={<AuthGuard><GamesList /></AuthGuard>} />
        <Route path="/subscriptions" element={<AuthGuard><Subscribe /></AuthGuard>} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}

function NotFound() {
  return <h1>404 - Page Not Found</h1>;
}

export default App;
